module.exports = __webpack_public_path__ + "static/img/Ten of Swords.601ecaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ten of Swords.jpg
// module id = 1306
// module chunks = 0